import {Expression, ExpressionElement} from '@packages/systems/wfdl-ast';
import {isRichText} from '@packages/utilities/elementTypeUtils';
import {findFurthestAncestor} from '@packages/utilities/core-elements';

export const isRichTextDescendant = (
  rootExpr: Expression,
  element: ExpressionElement
): boolean => {
  return Boolean(findFurthestAncestor(rootExpr, element, isRichText));
};
